import React, { Component } from "react";
import hw from "../../Images/hw.svg";
import oc from "../../Images/oc.svg";
import notifs from "../../Images/notifs.svg";
import events from "../../Images/events.svg";
import gallery from "../../Images/gallery.svg";
import holidays from "../../Images/holidays.svg";
import payments from "../../Images/payments.svg";
import complaints from "../../Images/complaints.svg";
import attendence from "../../Images/attendence.svg";
import downloads from "../../Images/downloads.svg";
import results from "../../Images/results.svg";
import grpsms from "../../Images/grpsms.png";
import numsms from "../../Images/numsms.png";
import tchrsms from "../../Images/tchrsms.png";
import stndsms from "../../Images/stndsms.png";
import { connect } from "react-redux";
import Authorize from "../../../../global/Authorize";
import Visible from "../../../../global/Visible";
import Skeleton from "react-loading-skeleton";
import HeaderV2 from "../../Layout/Header";
import HomeProfileCardV2 from "../../Components/Home/ProfileCardV2";
import BodyCard from "../../Components/Home/BodyCard";
import HeadCard from "../../Components/TeacherHome/HeadCard";
import Axios from "axios";
import Cover from "../../../Assets/img/default-cover-image.svg";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class TeacherHomeV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      UpcomingEventData: [],
      loading: true,
      fakeData: [1, 2, 3],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Home";

    var dt = new Date();

    this.fetchUpcomingEventData({
      session: this.props?.user?.session?.id,
    });
    this.fetchAssignedClassSubject({
      school: this.props.user.user.school.id,
      user__username: this.props.user.user?.username,
    });
  }

  fetchAssignedClassSubject = (params = {}) => {
    Axios.get(`/api/staff`, {
      params: { ...params },
      type: "json",
    }).then((res) => {
      localStorage.setItem(
        "assignedClassSubject",
        res.data.results?.length > 0 ? JSON.stringify(res.data.results[0]) : []
      );
    });
  };

  fetchUpcomingEventData = (params = {}) => {
    Axios.get("/mApiV1/EventsList", { params: { ...params } })
      .then((res) => {
        this.setState({ UpcomingEventData: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  render() {
    const handelDt = (dt) => {
      var j = dt % 10,
        k = dt % 100;
      if (j === 1 && k !== 11) {
        return dt + "st";
      }
      if (j === 2 && k !== 12) {
        return dt + "nd";
      }
      if (j === 3 && k !== 13) {
        return dt + "rd";
      }
      return dt + "th";
    };
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const handleDate = (date1, date2) => {
      let year1 = new Date(date1).getFullYear();
      let month1 = new Date(date1).getMonth();
      let dt1 = new Date(date1).getDate();

      let year2 = new Date(date2).getFullYear();
      let month2 = new Date(date2).getMonth();
      let dt2 = new Date(date2).getDate();

      year1 = year1 % 100;
      year2 = year2 % 100;
      if (year1 === year2) {
        if (month1 === month2) {
          if (dt1 === dt2) {
            return `${handelDt(dt1)} ${monthNames[month1]}, ${year1}`;
          } else {
            return `${handelDt(dt1)}-${handelDt(dt2)} ${
              monthNames[month1]
            }, ${year1}`;
          }
        } else {
          return `${handelDt(dt1)} ${monthNames[month1]} - ${handelDt(dt2)} ${
            monthNames[month2]
          }, ${year1}`;
        }
      } else {
        return `${handelDt(dt1)} ${monthNames[month1]}  ${year1} - ${handelDt(
          dt2
        )} ${monthNames[month2]}, ${year2}`;
      }
    };

    return (
      <Authorize
        roles={["IS_TEACHER", "IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/login"
      >
        <HeaderV2 to="/home" title="Home" />
        <div className="">
          <div
            className="pb-1"
            style={{
              width: "200%",
              overflow: "hidden",
              background:
                "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
              borderBottomLeftRadius: "56.25%",
              borderBottomRightRadius: "56.25%",
              paddingBottom: "20px",
              margin: "0px 0px  0px -50%",
            }}
          >
            <HomeProfileCardV2 />
            <div className="row my-auto mx-auto" style={{ width: "50%" }}>
              <Visible roles={["IS_TEACHER", "IS_PRINCIPAL"]}>
                <div className="col-4 mb-4">
                  <HeadCard
                    route="/uploadHomework"
                    image={hw}
                    label="Homework"
                  />
                </div>
              </Visible>
              <Visible roles={["IS_TEACHER", "IS_ADMIN", "IS_SUPERADMIN"]}>
                <div className="col-4 mb-4">
                  <HeadCard
                    route="/onlineclass"
                    image={oc}
                    label="Live Class"
                  />
                </div>
              </Visible>
              <Visible roles={["IS_PRINCIPAL"]}>
                <div className="col-4 mb-4">
                  <HeadCard
                    route="/allComplaint"
                    image={complaints}
                    label="All Complaints"
                  />
                </div>
              </Visible>
              <Visible roles={["IS_TEACHER"]}>
                <div className="col-4 mb-4">
                  <HeadCard
                    route="/attendance"
                    image={attendence}
                    label="Student Attendance"
                  />
                </div>
              </Visible>
              <Visible roles={["IS_PRINCIPAL"]}>
                <div className="col-4 mb-4">
                  <HeadCard
                    route="/attendancep"
                    image={attendence}
                    label="Student Attendance"
                  />
                </div>
              </Visible>
              <Visible roles={["IS_ADMIN", "IS_SUPERADMIN"]}>
                <div className="col-4 mb-4">
                  <HeadCard
                    route="/maindashboard"
                    image={attendence}
                    label="Dashboard"
                  />
                </div>
              </Visible>
              <Visible roles={["IS_ADMIN", "IS_SUPERADMIN"]}>
                <div className="col-4 mb-4">
                  <HeadCard
                    route="/termWiseFee"
                    image={payments}
                    label="Fee Statistics"
                  />
                </div>
              </Visible>
            </div>
          </div>

          <div>
            {this.state?.UpcomingEventData ? (
              <>
                <div className="container">
                  {this.state?.UpcomingEventData?.length !== 0 &&
                  this.state.loading === false ? (
                    <h5 className="th-16 mt-4 mb-3  text-center th-fw-600">
                      Upcoming Events
                    </h5>
                  ) : null}
                </div>
                <div
                  className="d-flex flex-row th-no-scroll"
                  style={{ overflowX: "scroll" }}
                >
                  {this.state.loading ? (
                    <>
                      {this.state.fakeData?.map((item, index) => (
                        <div key={index}>
                          <Skeleton
                            className="ml-3 overflow-hidden"
                            height={180}
                            width={240}
                          />
                        </div>
                      ))}
                      <div className="px-2"></div>
                    </>
                  ) : (
                    <>
                      {this.state.UpcomingEventData?.map((item, index) => (
                        <div key={index}>
                          <div
                            className="ml-3 overflow-hidden"
                            style={{
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "cover",
                              backgroundPosition: "center",

                              backgroundImage: `url(${
                                item?.event_image ? item?.event_image : Cover
                              })`,

                              // backgroundImage: `url(${item.event_image})`,
                              borderRadius: 16,
                            }}
                          >
                            <div
                              className="d-flex align-items-end"
                              style={{
                                height: 180,
                                minWidth: 240,
                                width: 240,
                                padding: 16,
                                background:
                                  "linear-gradient(360deg, rgba(0, 0, 0, 0.81) 0%, rgba(0, 0, 0, 0.400781) 31.77%, rgba(0, 0, 0, 0) 100%)",
                              }}
                            >
                              <div className="">
                                <h6
                                  className="th-14 mb-0 text-white"
                                  style={{ width: 180 }}
                                >
                                  {item?.event_name}
                                </h6>
                                <p
                                  className="th-12 text-truncate mb-0 text-light"
                                  style={{ width: 208 }}
                                >
                                  {handleDate(item?.from_date, item?.to_date)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      <div className="px-2"></div>
                    </>
                  )}
                </div>
              </>
            ) : null}
          </div>

          <div className="container th-16  mt-4 mb-2 th-fw-600 text-center">
            Explore
          </div>

          <div className="row px-3 my-3">
            <div className="col-4 mb-4">
              <BodyCard route="/gallery" image={gallery} label="Gallery" />
            </div>

            <div className="col-4 mb-4">
              <BodyCard route="/events" image={events} label="Events" />
            </div>
            <div className="col-4 mb-4">
              <BodyCard route="/holidays" image={holidays} label="Holidays" />
            </div>
            <div className="col-4 mb-4">
              <BodyCard
                route="/tnotifications"
                image={notifs}
                label="Notifications"
              />
            </div>
            <Visible roles={["IS_TEACHER"]}>
              <div className="col-4 mb-4">
                <BodyCard
                  route="/prevComplaint"
                  image={complaints}
                  label="Complaints"
                />
              </div>
            </Visible>
            <Visible roles={["IS_TEACHER", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 mb-4">
                <BodyCard route="/addmarks" image={results} label="Add Marks" />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN"]}>
              <div className="col-4 mb-4">
                <BodyCard
                  route="/allComplaint"
                  image={complaints}
                  label="All Complaints"
                />
              </div>
            </Visible>
            <Visible roles={["IS_TEACHER"]}>
              <div className="col-4 mb-4">
                <BodyCard
                  route="/attStaff"
                  image={attendence}
                  label="My Attendance"
                />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 mb-4">
                <BodyCard
                  route="/attSummary"
                  image={attendence}
                  label="Attendance Summary"
                />
              </div>
            </Visible>
            <Visible roles={["IS_TEACHER"]}>
              <div className="col-4 mb-4">
                <BodyCard route="/birthday" image={events} label="Birthday" />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 mb-4">
                <BodyCard
                  route="/downloads"
                  image={downloads}
                  label="Downloads"
                />
              </div>
            </Visible>

            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 mb-4">
                <BodyCard route="/grpsms" image={grpsms} label="Group SMS" />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 mb-4">
                <BodyCard
                  route="/smstemplate"
                  image={results}
                  label="SMS Template"
                />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 mb-4">
                <BodyCard
                  route="/studentsms"
                  image={stndsms}
                  label="Student SMS"
                />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 mb-4">
                <BodyCard route="/staffsms" image={tchrsms} label="Staff SMS" />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 mb-4">
                <BodyCard
                  route="/numbersms"
                  image={numsms}
                  label="SMS to Number"
                />
              </div>
            </Visible>
          </div>
        </div>
      </Authorize>
    );
  }
}

export default connect(mapStateToProps)(TeacherHomeV2);
